__webpack_require__.p = "https://trial.variantconfigurator.com/";